module.exports = __webpack_public_path__ + "img/background1.d41f783d.png";